class SearchHistory {
  set(val){
    if(val && val.trim().length > 0){
      let historyArray = this.get();
      historyArray.unshift(val)
      //去重
      historyArray = noRepeat(historyArray)
      if(historyArray.length > 10){
        historyArray = historyArray.slice(0,10)
      }
      localStorage.setItem("searchHistory",JSON.stringify(historyArray))
    }
  }
  get(){
    let historyArray = []
    const history = localStorage.getItem("searchHistory")
    if(history){
      historyArray = eval(history)
    }
    return historyArray
  }
  clear(){
    localStorage.removeItem("searchHistory")
  }
}

function noRepeat(arr){
  let newArr = [...new Set(arr)]
  return newArr
}
export default new SearchHistory();



// WEBPACK FOOTER //
// ./src/utils/history.js